import { Inject, Injectable } from "@angular/core";
import saveAs from 'file-saver';
import { Platform } from "ionic-angular";
import { Observable } from "rxjs";
import { EventNameAnalytics } from "../../helpers/event-name-analytics";
import { AnalyticsProvider } from "../../providers/analytics/analytics";
import { FileDownloaderProvider } from "../../providers/file-downloader/file-downloader";
import { RequestDownloadExcelDto, RequestReportSendEmailExcelDto, RequestReportSendEmailPdfDto } from "../../shared/nestjs/gd-only/dto/emp-ovt-report.dto";
import { EmpOvtPHReportApi } from "../../shared/nestjs/gd-only/services/emp-ovt-ph-report.api";
import { EmpOvtReportApi } from "../../shared/nestjs/gd-only/services/emp-ovt-report.api";
import { NestApiProvider } from "../../shared/nestjs/nest-api";
import { LoopBackAuth } from "../../shared/sdk/services/core";
import { ViewEmpOvtReportApi } from "../../shared/sdk/services/custom";
@Injectable()
export class EmpOvertimeReportBloc {
  constructor(
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    private nestApiProvider: NestApiProvider,
    private fileDownloaderProvider: FileDownloaderProvider,
    private platform: Platform,
    private viewEmpOvtReportApi: ViewEmpOvtReportApi,
    private empOvtReportApi: EmpOvtReportApi,
    private empOvtPHReportApi: EmpOvtPHReportApi,
    private analyticsProvider: AnalyticsProvider,
  ) {
  }

  generatePreview(obj_data): Observable<any> {
    return this.viewEmpOvtReportApi.previewReport(obj_data);
  }

  downloadExcel(data: RequestDownloadExcelDto): Observable<any> {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
    return this.empOvtReportApi.downloadExcel(data)
  }

  downloadExcelLB(data): Promise<any> {
    return new Promise(async (resolve, reject) => {

    })
  }

  generateExcel(data, fileName =  'Overtime Report') {
    if (this.platform.is('cordova')) {
      this.fileDownloaderProvider.downloadExcelBlob(data, fileName)
    } else {
      saveAs(data, `${fileName}.xlsx`)
    }
  }

  downloadPdf(data): Observable<any> {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_PDF);
    return this.empOvtReportApi.downloadPdf(data)
  }

  generatePdf(data, fileName =  'Overtime Report') {
    if (this.platform.is('cordova')) {
      this.fileDownloaderProvider.downloadPdfBlob(data, fileName)
    } else {
      saveAs(data, `${fileName}.pdf`)
    }
  }

  generatePdfLB(data): Promise<any> {
    return new Promise(async (resolve, reject) => {

    })
  }

  sendExcel(data): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
          let dataNest: RequestReportSendEmailExcelDto = new RequestReportSendEmailExcelDto();
          dataNest.allEmp = data.allEmp || 1;
          dataNest.listEmp = data.listEmp || [];
          dataNest.email = data.emailUser;
          dataNest.fullName = data.fullName;
          dataNest.startDate = data.startDate;
          dataNest.endDate = data.endDate
          return this.empOvtReportApi.reportSendEmailExcel(dataNest)
        } else {
          data.sendEmail = true;
          return this.viewEmpOvtReportApi.download(data)
        }
      })
  }

  sendPdf(data): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
          let dataNest: RequestReportSendEmailPdfDto = new RequestReportSendEmailPdfDto();
          dataNest.allEmp = data.allEmp || 1;
          dataNest.listEmp = data.listEmp || [];
          dataNest.email = data.emailUser;
          dataNest.fullName = data.fullName;
          dataNest.startDate = data.startDate;
          dataNest.endDate = data.endDate
          return this.empOvtReportApi.reportSendEmailPdf(dataNest)
        } else {
          data.sendEmail = true;
          return this.viewEmpOvtReportApi.pdfmake(data)
        }
      })
  }

  downloadExcelPH(data: RequestDownloadExcelDto): Observable<any> {
    return this.empOvtPHReportApi.downloadExcel(data)
  }

  generateExcelPH(data) {
    if (this.platform.is('cordova')) {
      this.fileDownloaderProvider.downloadExcelBlob(data, 'Overtime PH Report')
    } else {
      saveAs(data, 'Overtime PH Report.xlsx')
    }
  }

  downloadPdfPH(data): Observable<any> {
    return this.empOvtPHReportApi.downloadPdf(data)
  }

  generatePdfPH(data) {
    if (this.platform.is('cordova')) {
      this.fileDownloaderProvider.downloadPdfBlob(data, 'Overtime PH Report')
    } else {
      saveAs(data, 'Overtime PH Report.pdf')
    }
  }

  sendExcelPH(data): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
          let dataNest: RequestReportSendEmailExcelDto = new RequestReportSendEmailExcelDto();
          dataNest.allEmp = data.allEmp || 1;
          dataNest.listEmp = data.listEmp || [];
          dataNest.email = data.emailUser;
          dataNest.fullName = data.fullName;
          dataNest.startDate = data.startDate;
          dataNest.endDate = data.endDate
          return this.empOvtPHReportApi.reportSendEmailExcel(dataNest)
        }
      })
  }

  sendPdfPH(data): Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        if (isGoPathNewExist) {
          this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
          let dataNest: RequestReportSendEmailPdfDto = new RequestReportSendEmailPdfDto();
          dataNest.allEmp = data.allEmp || 1;
          dataNest.listEmp = data.listEmp || [];
          dataNest.email = data.emailUser;
          dataNest.fullName = data.fullName;
          dataNest.startDate = data.startDate;
          dataNest.endDate = data.endDate
          return this.empOvtPHReportApi.reportSendEmailPdf(dataNest)
        }
      })
  }

}



// WEBPACK FOOTER //
// ./src/bloc/report/emp-overtime-report.bloc.ts